import React from 'react'
import './squaresBackground.css';

function SquaresBackground() {
  return (
    <div className='squares-bg-container'>
        <ul class="background">
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
</ul>




    </div>
  )
}

export default SquaresBackground